import React, { useState, useEffect, useCallback, useRef } from 'react';
import './Pagination.css';
import { protectedAPI } from '../services/api';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import ReactTimeAgo from 'react-time-ago';

const accessRules = [
  {
    value: 'allowed',
    label: 'Разрешен',
  },
  {
    value: 'forbidden',
    label: 'Запрещён',
  }
];

function formatDate(date_to_format) {
  var date = new Date(date_to_format);
  return date.toLocaleString("ru");
}

export const TableSearch = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const isFirstRender = useRef(true);

  const handleSearch = useCallback((term) => {
    
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    
    onSearch({number: term});
  }, [onSearch]);

  useEffect(() => {

    const timeoutId = setTimeout(() => {
      handleSearch(searchTerm);
    }, 500);

    return () =>  {
      clearTimeout(timeoutId);
    };
    
  }, [searchTerm]);

  return (
    <div className="table-search">
      <input
        type="text"
        placeholder="Поиск по номеру..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-input"
      />
    </div>
  );
};

export const JournalTableRow = ({ data }) => {

  const [openJournal, setOpenJournal] = useState(false);

  const handleClickOpenJournal = () => {
    setOpenJournal(true);
  };

  const handleCloseJournal = () => {
    setOpenJournal(false);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('ru-RU');
  };

  return (
    <tr className="table-row">
      <td>
        <div className="license-plate">
          {data.license_plate_number_ru || 'Не найден'}
        </div>
      </td>
      
      <td>
        {data.address}
      </td>

      <td>
        {data.camera}
      </td>
      
      <td>
        <ReactTimeAgo date={data.recognized_at} locale="ru"/>
      </td>
      
      <td style={data.access_granted ? {color: 'green'} : {color: 'red'}}>
        {data.access_granted ? 'Разрешен' : 'Запрещен'}
      </td>

      <td>
        <Button variant="outlined" onClick={handleClickOpenJournal}>
          Просмотр
        </Button>
        <Dialog
          open={openJournal}
          onClose={handleCloseJournal}
          aria-labelledby="view-number-dialog-title"
          aria-describedby="view-number-dialog-description"
        >
          <DialogTitle id="view-number-dialog-title">
            Информация о событии:
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="view-number-dialog-description">
              <Box
                component="form"
                sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
                noValidate
                autoComplete="off"
              >
                <TextField
                  id="journal-address"
                  label="Адрес"
                  defaultValue={data.address}
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                />
                <TextField
                  id="journal-camera"
                  label="Камера"
                  defaultValue={data.camera}
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                />
                <TextField
                  id="journal-number"
                  label="Номер"
                  defaultValue={data.license_plate_number_ru}
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                />
                <TextField
                  id="journal-recognized-at"
                  label="Распознан"
                  defaultValue={formatDate(data.recognized_at)}
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                />
                <TextField
                  id="journal-access"
                  label="Проезд"
                  color={data.access_granted ? 'success' : 'error'}
                  focused
                  defaultValue={data.access_granted ? 'Разрешен' : 'Запрещен'}
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                />
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseJournal}>Закрыть</Button>
          </DialogActions>
        </Dialog>
      </td>
      
    </tr>
  );
};

export const NumberTableRow = ({ data }) => {

  const [prevLicensePlate, setPrevLicensePlate] = useState(null);
  const [prevAccessRule, setPrevAccessRule] = useState(null);
  const [licensePlate, setLicensePlate] = useState(data);
  const [selectedValue, setSelectedValue] = useState(data.access_rule);
  const selectedValueRef = useRef(selectedValue);
  const [number, setNumber] = useState('');
  const numberRef = useRef(data.number_ru);
  const [numberError, setNumberError] = useState(false);
  const [allowNumberChange, setAllowNumberChange] = useState(false);

  const [openChangeNumber, setOpenChangeNumber] = useState(false);
  const [openViewNumber, setOpenViewNumber] = useState(false);
  const [openDeleteNumber, setOpenDeleteNumber] = useState(false);

  const [openChangeNumberNotify, setOpenChangeNumberNotify] = useState(false);
  const [openDeleteNumberNotify, setOpenDeleteNumberNotify] = useState(false);

  const handleClickOpenChangeNumber = () => {
    setOpenChangeNumber(true);
  };

  const handleCloseChangeNumber = () => {

    setAllowNumberChange(false);
    setOpenChangeNumber(false);
  };

  const handleChangeNumber = () => {
    if (numberRef.current != licensePlate.number_ru) {
      //numberRef.current = licensePlate.number_ru;
      setPrevLicensePlate(licensePlate.number_ru);
    }
    else
      setPrevLicensePlate(null);
    if (selectedValueRef.current != licensePlate.access_rule)
      setPrevAccessRule(licensePlate.access_rule);
    else
      setPrevAccessRule(null);

    setAllowNumberChange(false);

    fetchUpdate();
  };

  const checkAllowNumberChange = () => {
    if ((selectedValueRef.current != licensePlate.access_rule) || (numberRef.current != licensePlate.number_ru))
      setAllowNumberChange(true);
    else
      setAllowNumberChange(false);
  };

  const handleAccessRuleChange = (e) => {
    const value = e.target.value;
    setSelectedValue(value);
    selectedValueRef.current = e.target.value;
    checkAllowNumberChange();
  };

  const handleNumberTextFieldChange = e => {
    setNumber(e.target.value);
    numberRef.current = e.target.value;
    checkAllowNumberChange();
    if (e.target.validity.valid) {
      setNumberError(false);
    } else {
      setNumberError(true);
    }
  };

  const handleClickOpenViewNumber = () => {
    setOpenViewNumber(true);
  };

  const handleCloseViewNumber = () => {
    setOpenViewNumber(false);
  };

  const handleClickOpenDeleteNumber = () => {
    setOpenDeleteNumber(true);
  };

  const handleCloseDeleteNumber = () => {
    setOpenDeleteNumber(false);
  };

  const handleDeleteNumber = () => {
    fetchDelete();
  };

  const handleCloseDeleteNumberNotify = () => {
    setLicensePlate(null);
    setOpenDeleteNumberNotify(false);
  };

  const handleCloseChangeNumberNotify = () => {
    setOpenChangeNumberNotify(false);
  };

  const fetchUpdate = useCallback(async () => {
    try {
      const response = await protectedAPI.updatePlates(data.id, {
        user: data.user,
        address: data.address,
        number_ru: numberRef.current,
        access_rule: selectedValueRef.current,
      });
      setLicensePlate(response.data);
      setOpenChangeNumber(false);
      setOpenChangeNumberNotify(true);
    } catch (error) {
      //setError('Failed to fetch system state');
    } finally {
      //setLoading(false);
    }
  }, []);

  const fetchDelete = useCallback(async () => {
    try {
      const response = await protectedAPI.deletePlate(data.id);
      setOpenDeleteNumber(false);
      setOpenDeleteNumberNotify(true);
    } catch (error) {
      //setError('Failed to fetch system state');
    } finally {
      //setLoading(false);
    }
  }, []);

  if (licensePlate === null)
    return (<></>);

  return (
    <tr className="table-row">
      <td>
        <div className="license-plate">
          {licensePlate.number_ru || 'Не найден'}
        </div>
      </td>

      <td style={(licensePlate.access_rule == 'allowed') ? {color: 'green'} : {color: 'red'}}>
        {(licensePlate.access_rule == 'allowed') ? 'Разрешен' : 'Запрещён'}
      </td>
      
      <td>
        <ReactTimeAgo date={licensePlate.updated_at} locale="ru"/>
      </td>
      
      <td>
        <Box
          sx={{ '& > :not(style)': { mr: 1, mb: 0.5 } }}
        >
          <Button variant="outlined" onClick={handleClickOpenChangeNumber}>
            Изменить
          </Button>
          <Button variant="outlined" onClick={handleClickOpenViewNumber}>
            Просмотр
          </Button>
          <Button variant="outlined" onClick={handleClickOpenDeleteNumber}>
            Удалить
          </Button>
        </Box>
        
        <Dialog
          open={openChangeNumber}
          onClose={handleCloseChangeNumber}
          aria-labelledby="change-number-dialog-title"
          aria-describedby="change-number-dialog-description"
        >
          <DialogTitle id="change-number-dialog-title">
            Вы хотите изменить номер "{licensePlate.number_ru}"?
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="change-number-dialog-description">
              <Box
                component="form"
                sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
                noValidate
                autoComplete="off"
              >
                <TextField
                  required
                  id="new-number"
                  label="Номер"
                  defaultValue={licensePlate.number_ru}
                  onChange={handleNumberTextFieldChange}
                  error={numberError}
                  helperText={numberError && 'Ошибка! Пример: а001аа35'}
                  slotProps={{
                    htmlInput: {
                      pattern: "^[АВЕКМНОРСТУХавекмнорстух]{1}[0-9]{3}[АВЕКМНОРСТУХавекмнорстух]{2}[0-9]{2,3}"
                    },
                  }}
                />
                <TextField
                  id="new-rule-controlled"
                  select
                  label="Права доступа"
                  defaultValue={licensePlate.access_rule}
                  onChange={handleAccessRuleChange}
                >
                  {accessRules.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseChangeNumber}>Отменить</Button>
            <Button onClick={handleChangeNumber} autoFocus disabled={(!numberError && allowNumberChange) ? false : true}>
              Изменить
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openViewNumber}
          onClose={handleCloseViewNumber}
          aria-labelledby="view-number-dialog-title"
          aria-describedby="view-number-dialog-description"
        >
          <DialogTitle id="view-number-dialog-title">
            Информация о номере:
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="view-number-dialog-description">
              <Box
                component="form"
                sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
                noValidate
                autoComplete="off"
              >
                <TextField
                  id="number"
                  label="Номер"
                  defaultValue={licensePlate.number_ru}
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                />
                <TextField
                  id="access-rule"
                  select
                  label="Права доступа"
                  defaultValue={licensePlate.access_rule}
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                >
                  {accessRules.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  id="created-at"
                  label="Создан"
                  defaultValue={formatDate(licensePlate.created_at)}
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                />
                <TextField
                  id="updated-at"
                  label="Изменён"
                  defaultValue={formatDate(licensePlate.updated_at)}
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                />
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseViewNumber}>Закрыть</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openDeleteNumber}
          onClose={handleCloseDeleteNumber}
          aria-labelledby="delete-number-dialog-title"
        >
          <DialogTitle id="delete-number-dialog-title">
            Вы действительно хотите удалить номер {licensePlate.number_ru}?
          </DialogTitle>
          <DialogActions>
            <Button onClick={handleDeleteNumber}>Удалить</Button>
            <Button onClick={handleCloseDeleteNumber}>Отменить</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openChangeNumberNotify}
          onClose={handleCloseChangeNumberNotify}
          aria-labelledby="change-number-notify-dialog-title"
          aria-describedby="change-number-notify-dialog-description"
        >
          <DialogTitle id="change-number-notify-dialog-title">
            Номер {prevLicensePlate ? '' : licensePlate.number_ru} был успешно изменён!
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="change-number-notify-dialog-description">
              <Box
                component="form"
                sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
                noValidate
                autoComplete="off"
              >
                {prevLicensePlate && <TextField
                  id="notify-old-number"
                  label="Старый номер"
                  color='error'
                  focused
                  defaultValue={prevLicensePlate}
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                />}
                {prevLicensePlate && <TextField
                  id="notify-new-number"
                  label="Новый номер"
                  color='success'
                  focused
                  defaultValue={licensePlate.number_ru}
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                />}
                {prevAccessRule && <TextField
                  id="notify-old-access-rule"
                  select
                  color='error'
                  focused
                  label="Старые права доступа"
                  defaultValue={prevAccessRule}
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                >
                  {accessRules.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>}
                {prevAccessRule && <TextField
                  id="notify-new-access-rule"
                  select
                  color='success'
                  focused
                  label="Новые права доступа"
                  defaultValue={licensePlate.access_rule}
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                >
                  {accessRules.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>}
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseChangeNumberNotify}>ОК</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openDeleteNumberNotify}
          onClose={handleCloseDeleteNumberNotify}
          aria-labelledby="delete-number-notify-dialog-title"
        >
          <DialogTitle id="delete-number-notify-dialog-title">
            Номер {licensePlate.number_ru} был успешно удалён!
          </DialogTitle>
          <DialogActions>
            <Button onClick={handleCloseDeleteNumberNotify}>ОК</Button>
          </DialogActions>
        </Dialog>
      </td>
      
    </tr>
  );
};
